// extracted by mini-css-extract-plugin
export var actions = "_r8-4";
export var item = "_r8-1";
export var price = "_r8-3";
export var quantity = "_r8-2";
export var table = "_r8-0";